export default __webpack_public_path__ + "static/AKB_Auryxia_MOA_TitleCard-69db9933b47cd9127c47303d07b5252f.png";